// src/layouts/AdminLayout.js
import { Box, Flex, Spinner } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../components/Admin/AdminSidebar';
import AdminNavbar from '../components/Admin/AdminNavbar';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase';
import { Navigate } from 'react-router-dom';

const AdminLayout = () => {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return (
      <Flex justify="center" align="center" h="100vh">
        <Spinner size="xl" />
      </Flex>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Box minH="100vh" bg="customDark" >
      <AdminNavbar />
      <Flex pt="60px">
        <AdminSidebar />
        <Box flex="1" p={6}>
          <Outlet />
        </Box>
      </Flex>
    </Box>
  );
};

export default AdminLayout;